<template>
  <div class="address-form">
    <template v-for="field in filteredCountryCodeFields">
      <div
        v-if="['name', 'country', 'lineFields'].includes(field)"
        :key="field">
        <component
          :address-config="addressConfig"
          :countries="countries"
          :name="name"
          :key="field"
          :address="form"
          :labels="labels"
          :separate-line-one-fields="splitLineOneFields"
          :separate-line-three-fields="splitLineThreeFields"
          :is="`${field}`"
          :is-disabled="checkDisabled(field)"
          :name-field-required = "checkNameRequired()"
          @input="input"
          @blur="blur"
          @updateCountryCode="updateCountryCode"
        />
      </div>
      <div
        v-else-if="Array.isArray(field)"
        :key="field.join('-')"
        class="row">
        <component
          v-for="currentField in field"
          :key="currentField"
          :address-config="addressConfig"
          :countries="countries"
          :name="name"
          :address="form"
          :labels="labels"
          :is-disabled="checkDisabled(currentField)"
          :is="`${currentField}`"
          @input="input"
          @blur="blur"
        />
      </div>
      <div
        v-else
        :key="field"
        class="row">
        <component
          :address-config="addressConfig"
          :countries="countries"
          :name="name"
          :address="form"
          :labels="labels"
          :is-disabled="checkDisabled(field)"
          :is="`${field}`"
          @input="input"
          @blur="blur"
        />
      </div>
    </template>
    <button
      class="btn btn-primary btn-lg mt-3"
      @click="saveAddress">Save</button>
    <button
      class="btn btn-white border-primary text-primary btn-lg mt-3 ml-3"
      @click="clearAddress">Clear</button>
  </div>
</template>

<script>
import country from './components/country'
import lineFields from './components/lineFields'
import city from './components/city'
import state from './components/state'
import zip from './components/zip'
import name from './components/name'

import sanitize from '@/utils/sanitize'
import AddressService from './address.service'
import { BAI_FIELDS_CONFIGURATION } from '@/utils/constant'

let addressService = new AddressService()

export default {
  name: 'AddressForm',
  inject: ['$validator'],
  components: {
    name,
    country,
    lineFields,
    city,
    state,
    zip
  },
  model: {
    prop: 'address',
    event: 'input'
  },
  props: {
    address: {
      type: Object,
      default: Object
    },
    name: {
      type: String,
      required: true
    },
    labels: {
      type: Object,
      required: true
    },
    countries: {
      type: Object,
      required: true
    },
    enableNameField: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      userCountryCode: this.address.countryCode || ''
    }
  },
  computed: {
    countryConfig () {
      return addressService.getCountryConfig(this.userCountryCode, false) || {}
    },

    addressConfig () {
      return this.countryConfig.address || {}
    },

    currentCountryCodeFields () {
      const defaultSortOrder = [ 'name', 'country', 'lineFields', 'city', ['state', 'zip'] ]
      return this.countryConfig.addressFieldsSortOrder || defaultSortOrder
    },

    filteredCountryCodeFields () {
      return this.currentCountryCodeFields.filter((field) => {
        return JSON.stringify(field) !== JSON.stringify(this.splitLineOneFields) && JSON.stringify(field) !== JSON.stringify(this.splitLineThreeFields)
      })
    },

    splitLineOneFields () {
      return this.currentCountryCodeFields.find((field) => {
        return field.includes('streetName') && field.includes('streetNumber')
      }) || []
    },

    splitLineThreeFields () {
      return this.currentCountryCodeFields.find((field) => {
        return field.includes('complemento') && field.includes('neighborhood')
      }) || []
    },

    form () {
      return this.address
    }
  },
  methods: {

    checkNameRequired () {
      let billingAddressPreference = this.$store.getters.billingAddress
      if (billingAddressPreference === 'FULL') {
        return true
      }
      return false
    },

    checkDisabled (fieldName) {
      let billingAddressSelection = this.$store.getters.billingAddress
      let activeBAIFields = BAI_FIELDS_CONFIGURATION[billingAddressSelection]
      return !activeBAIFields.includes(fieldName)
    },

    async updateCountryCode (countryCode) {
      this.userCountryCode = countryCode
      let billingAddressName = this.form.name || this.address.name
      this.$store.commit('changeConsumerBillingAddress', {
        name: billingAddressName,
        countryCode: this.userCountryCode
      })
      await this.$validator.reset()
      this.normalizeAddressFields(this.form)
      this.$emit('input', this.form)
    },

    input () {
      this.$emit('input', this.form)
    },

    blur () {
      this.$emit('input', sanitize(this.form))
    },

    async saveAddress () {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        this.$store.commit('changeConsumerBillingAddress', sanitize(this.form))
        this.$emit('billing-address-save', true)
      }
      // TODO: need to remove this console further. its just for testing for now
      console.log('After submit', this.$store.getters.consumerBillingAddress)
    },

    normalizeAddressFields (address) {
      const fieldMap = {
        line1: 'line1',
        line2: 'line2',
        line3: 'line3',
        cityTown: 'city',
        subdivision: 'state',
        postalCode: 'zip'
      }

      for (const configField in fieldMap) {
        const { enabled } = (this.addressConfig && this.addressConfig[configField]) || {}
        const addressField = fieldMap[configField]

        if (!enabled && address.hasOwnProperty(addressField)) {
          delete address[addressField]
        }
      }
    },

    async clearAddress () {
      this.$store.commit('resetConsumerBillingAddress')
      await this.$validator.reset()
    }
  }
}
</script>
